import React from 'react';

const {
  tagsJson,
} = require('./tags/gifta/tags');

const logoStyle = {
  height: 60,
  display: 'block',
  margin: '0 auto',
};

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const GiftaTheme = {
  headerLogo: {
    src: '/themes/theme/gifta/logo.png',
    alt: 'Gifta Logo',
    size: 45,
  },
  darkLogo: {
    // use new logo
    // src: '/themes/theme/gifta/logo_dark.png',
    src: '/themes/theme/gifta/logo.png',
    alt: 'Gifta Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 60,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Gifta',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src="/themes/theme/gifta/logo.png" alt="Gifta Logo"
      />
      <br /><br />
      <h3>influencer campaign tracking</h3>
    </div>
  ),
  shareSite: 'https://share.gifta.co.uk',
  organisationId: '2beaa438-af69-46f1-b639-f7ae1f374241',
  dobRequired: true,
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: '/themes/theme/gifta/logo.png',
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
  primaryButtonColorStyle: {
    background: '#8068ab',
    color: 'white',
    margin: 5,
  },
  tagButtonColor: 'violet',
  formTitle: () => (
    <h3 style={textAlignCentre}>Create your profile</h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>welcome to gifta.</p>
      <br />
      <p style={textAlignCentre50p}>Sign up to Gifta and start receiving campaign offers best suited to your feed and audience.
      We only send you gifted products for campaigns you want to work on.</p>
      <br />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>To become part of the Gifta family, we have some simple guidelines to follow;</p>
      <br />
      <p style={textAlignCentre}>1. If you love it, share it and tag all relevant parties</p>
      <br />
      <p style={textAlignCentre}>2. Be authentic but get creative in your own unique style</p>
      <br />
      <p style={textAlignCentre}>3. If you’re not feeling the love,
  please provide honest and constructive feedback to be eligible for future campaigns</p>
      <br />
      <p style={textAlignCentre}>4. The more content you share,
  the more our brands will choose you for future campaigns</p>
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Thanks for signing up to the Gifta platform.
      We will review your application and get in touch with any suitable gifting campaigns for you.</p>
      <br />
      <p style={textAlignCentre}>Please head over to our instagram account and hit the follow button.
      This is the best way to keep up to date with upcoming campaigns!!</p>
      <br />

      <br />
      <p style={textAlignCentre}>
        <a href="https://to.mysocial.io/s/wbmXLkFD7">
          <img
            href="https://to.mysocial.io/s/wbmXLkFD7"
            className="logo"
            style={logoStyle}
            src="/themes/theme/gifta/instagram.png"
            alt="Gifta Instagram"
          />
        </a>
        <a href="https://to.mysocial.io/s/wbmXLkFD7">Our Instagram page</a>
      </p>      <br />
    </div>
  ),
  tagsHtmlTop: () => (
    <div>
      <div>Tags</div>
      <div className="spacer small" />
      <p style={textAlignCentre}>How would you describe your content style? (please select at least one)</p>
      <div className="spacer small" />
    </div>
  ),
  socialHandle2HtmlBottom: () => (
    <p style={textAlignCentre}>if none to add, please click next</p>
  ),
  socialHandle3HtmlBottom: () => (
    <p style={textAlignCentre}>if none to add, please click next</p>
  ),
  // tagsJson, //GIfta requested to hide the tags screen
  privacyPolicyUrl: 'https://docs.google.com/document/d/1zcG9POSaSwpbadmCJJSq_L0WH4cYPU3YaIL8Ccajdw0/edit?usp=sharing',
};

export default GiftaTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/gifta.js
 **/